import Vue from 'vue';
import { tns } from 'tiny-slider/src/tiny-slider';

Vue.component('image-slider', {
    props: {
        sliderId: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {};
    },

    mounted() {
        this.slider = tns({
            container: '#' + this.sliderId,
            items: 1,
            slideBy: 'page',
            controls: false,
            navContainer: '#' + this.sliderId + '--nav',
            autoplay: true,
            speed: 1000,
            autoplayTimeout: 8000,
            autoplayButtonOutput: false,
            autoplayHoverPause: true
        });
    }
});
